import actions from './actions'

const initialState = {
  hashLoading: true,
  hashToken: '',
  postpaymentloading: false,
  transactionResult: false,
  paymentResult: false,
  paymentResultMessage: ''
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
